import { render } from "./Externo.vue?vue&type=template&id=97f34544&scoped=true"
import script from "./Externo.vue?vue&type=script&lang=js"
export * from "./Externo.vue?vue&type=script&lang=js"

import "./Externo.vue?vue&type=style&index=0&id=97f34544&lang=scss&scoped=true"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/transparencia-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97f34544"]])

export default __exports__